module.exports = __webpack_public_path__ + "static/img/4.ace756a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/4.png
// module id = ePla
// module chunks = 0